import moment from 'moment';
import queryString from 'qs';

const getExportGetReportHelpPartner = (filter) => {
  const queries = {};

  if (filter?.search) queries['search'] = filter.search;
  if (filter?.sort) queries['sort'] = `${filter.sort.field}.${filter.sort.order}`;
  if (filter?.studioId) queries['studioId'] = filter.studioId.value;
  if (filter?.startedAt) queries['startedAt'] = moment(filter.startedAt).format('DD-MM-YYYY');
  if (filter?.endedAt) queries['endedAt'] = moment(filter.endedAt).format('DD-MM-YYYY');

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getExportGetReportHelpPartner;
